import Vue from 'vue';

import Router from 'vue-router';

import axios from 'axios';

import isAuthenticated from './guards/isAuthenticated';
import userInfo from './services/user-info';
import store from './store/index';
import AllowBlockLists from './views/AllowBlockLists.vue';
import Login from './views/AuthLogin.vue';
import Register from './views/AuthRegister.vue';
import Events from './views/Events.vue';
import Interfaces from './views/Interfaces.vue';
import Network from './views/Network.vue';
import Playlists from './views/Playlists.vue';
import Settings from './views/Settings.vue';
import Tags from './views/Tags.vue';
import Server from './views/Server.vue';
import Dashboard from './views/Dashboard.vue';
import Connections from './views/Connections.vue';
import Logout from './views/Logout.vue';



Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Interfaces,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/interfaces',
      name: 'Interfaces',
      component: Interfaces,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/connections',
      name: 'Connections',
      component: Connections,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      beforeEnter: isAuthenticated,
    },
    {
      path: '/access',
      name: 'access',
      component: AllowBlockLists,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/network',
      name: 'network',
      component: Network,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/tags',
      name: 'tags',
      component: Tags,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Events,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/playlists',
      name: 'playlists',
      component: Playlists,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/server',
      name: 'server',
      component: Server,
      beforeEnter: isAuthenticated,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },

  ],
  linkExactActiveClass: 'active', // active class for *exact* links.
});
